import { render, staticRenderFns } from "./PessoaView.vue?vue&type=template&id=da55644e"
import script from "./PessoaView.vue?vue&type=script&lang=js"
export * from "./PessoaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports